const ACREAGE_FORMATTER = new Intl.NumberFormat("en-CA", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const ACREAGE_INPUT_FORMATTER = new Intl.NumberFormat("en-CA", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: false,
});

function parseAcreage(value) {
  if (
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "")
  ) {
    return null;
  }

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
}

function formatAcres(value, fallback = "") {
  const numericValue = parseAcreage(value);
  return numericValue === null ? fallback : ACREAGE_FORMATTER.format(numericValue);
}

function formatAcresForInput(value) {
  const numericValue = parseAcreage(value);
  return numericValue === null ? "" : ACREAGE_INPUT_FORMATTER.format(numericValue);
}

export { formatAcres, formatAcresForInput };
